// This is a partial list of free/disposable email providers.
// The full list is maintained by HubSpot. This client-side check is to improve UX.
// Source: https://knowledge.hubspot.com/forms/what-domains-are-blocked-when-using-the-forms-email-domains-to-block-feature

const blockedDomains = new Set([
  // From HubSpot-provided list
  'mailinator.com',
  'company.com',
  'gaylord.com',
  'tasla.com',
  'gamil.com',
  'gemil.com',
  'fmail.com',
  'hmail.com',
  'blogspot.com',

  // Common free email providers
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'aol.com',
  'icloud.com',
  'live.com',
  'msn.com',
  'yandex.com',
  'mail.com',
  'gmx.com',
  'protonmail.com',
  'zoho.com',
]);

/**
 * Checks if the email address is from a business domain.
 * @param email The email address to validate.
 * @returns `true` if the email is a business email, `false` otherwise.
 */
export function isBusinessEmail(email: string): boolean {
  if (!email || !email.includes('@')) {
    return false;
  }
  const domain = email.split('@')[1]?.toLowerCase();
  return !blockedDomains.has(domain);
} 